export const getInvitationCodeFromLocalStorage = () => localStorage.getItem('invite_code');
export const insertInvitationCodeIntoLocalStorage = inviteCode => localStorage.setItem('invite_code', inviteCode);
